import React from 'react';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import CommonHeaderRight from './CommonHeaderRight';
import useDarkMode from '../../../hooks/useDarkMode';
import Popovers from '../../../components/bootstrap/Popovers';
import Button from '../../../components/bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { SubHeaderCenter } from '../../../layout/SubHeader/SubHeader';
import logo from '../../../assets/images/brand_dark.png';
import { useNavigate } from 'react-router-dom';
import { useMst } from '../../../models'
import { removeItem } from '../../../lib/localstorage';

const LoginHeader = () => {
	const deviceScreen = useDeviceScreen();
	const navigate = useNavigate();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const { t } = useTranslation(['translation', 'menu']);
	const { user, config } = useMst()

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const isSelected = (menu) => {
		return location.pathname === menu ? 'selected-topmenu' : 'topmenu'
	}

	return (
		<Header className='login-header'>
			<HeaderLeft>
				<div className='text-end' onClick={() => navigate('/')}>
					<Button>
						<img className='thumbnail' src={logo} alt='지음과 깃듬' />
					</Button>
				</div>
			</HeaderLeft>
			<SubHeaderCenter>
				<div className='row g-3 text-center topmenu-container'>
					<div className='col-auto'>
						<Button className={isSelected('/home')}
							onClick={() => navigate('/home')}
							color={'dark'}
							isLink={true}
						>
							Home
						</Button>
					</div>
					<div className='col-auto'>
						<Button className={isSelected('/icru')}
							onClick={() => navigate('/icru')}
							color={'dark'}
							isLink={true}
						>
							ICRU기질진단
						</Button>
					</div>
					<div className='col-auto'>
						<Button className={isSelected('/test')}
							onClick={() => navigate('/test')}
							color={'dark'}
							isLink={true}
						>
							진단하기
						</Button>
					</div>
				</div>
			</SubHeaderCenter>
			<HeaderLeft>
				<div className='row g-3 text-start mini-size'>
					<div className='col-auto'>
						{!user?.id &&
							<Button className='topmenu'
								onClick={() => {
									config.setPrevPage('/')
									navigate('/login')
								}}
								color={'dark'}
								isLink={true}
							>
								로그인
							</Button>}
						{user?.id > 0 &&
							<Button className='topmenu'
								// shadow={'lg'}
								isLink={true}
								color="info"
								onClick={() => {
									// navigate('/mypage')
								}}
							>
								{user.name}
							</Button>}
					</div>
					<div className='col-auto'>
						{!user?.id &&
							<Button className='topmenu'
								onClick={() => navigate('/signup')}
								color={'dark'}
								isLink={true}
							>
								회원가입
							</Button>}
						{user?.id > 0 &&
							<Button className='topmenu'
								onClick={() => {
									removeItem('access-token')
									removeItem('refresh-token')
									user.logout()
									navigate('/')
								}}
								color={'dark'}
								isLink={true}
							>
								로그아웃
							</Button>}
					</div>
				</div>
			</HeaderLeft>
			
			{/* <CommonHeaderRight /> */}
		</Header>
	);
};

export default LoginHeader;
